<template>
  <v-card>
    <v-card-title class="headline" dark-title> Insert URL </v-card-title>
    <v-card-text class="mb-3">
      <v-layout row justify-end>
        <v-flex xs2>
            <v-btn
              text
              color="yellow darken-4"
              class="m-w"
              @click="unzip_umbrella"
            >
              Analyze
              <v-icon>beach_access</v-icon>
            </v-btn>
        </v-flex>
        <v-flex xs2>
            <v-btn
              text
              color="red darken-4"
              class="m-w"
              @click="resetUrls"
            >
              <v-icon>replay</v-icon>Reset
            </v-btn>
        </v-flex>
        <v-flex xs2>
          <p class="text-xs-right">
            <v-btn text color="primary" class="m-w" @click="addNewProductUrl()">
              <v-icon>add</v-icon>
              Add url
            </v-btn>
          </p>
        </v-flex>
      </v-layout>
      <div class="add_url-wrapper">
        <div v-for="(item, key) in urlInfo" :key="key" class="add_url">
          <v-layout row justify-space-between align-end>
            <v-flex xs3>
              <p class="mb-2">Variation:</p>
              <v-select
                v-model="urlInfo[key].variation"
                :items="variations"
                label="Variations"
                class="ex-variation-dropdown ex-opacity-btn"
                item-text="value"
                item-value="id"
                solo
              >
              </v-select>
            </v-flex>
            <!-- <v-flex xs2>
              <p class="mb-2">Size:</p>
              <v-select
                v-model="urlInfo[key].size"
                :items="sizes"
                label="size"
                class="ex-variation-dropdown ex-opacity-btn"
                item-text="value"
                item-value="id"
                solo
              >
              </v-select>
            </v-flex> -->
            <v-flex xs8 class="d-flex">
              <v-text-field
                v-model="urlInfo[key].value"
                class="i-v-input"
                prepend-inner-icon="link"
                label="Product Link"
                single-line
                solo
              ></v-text-field>
              <v-btn
                text
                :disabled="urlInfo.length === 1"
                class="ex-btn"
                @click="deleteRow(key)"
              >
                <v-icon color="red darken-2">delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        :ripple="false"
        class="ma-0 me-15 px-10 py-5 ex-btn ex-primary-btn text--white"
        @click="validateLinks"
      >
        <!-- @click="saveProductLink()" -->
        Validate
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/* eslint-disable */
import { productionBus } from "@/helpers/buses";

export default {
  name: "N_AddUrl",
  data: () => ({
    urlInfo: [
      {
        variation: 0,
        value: "",
      }
    ],
    dataColor: [],
    dataSize: [],
  }),
  computed: {
    variations () {
        return this.$store.state.productionModule.variations;
    },
    // sizes () {
    //     return this.$store.state.productionModule.variations.size;
    // },
  },
  methods: {
    addNewProductUrl() {
      this.urlInfo.push({
        variation: 0,
        value: ""
      });
    },
    resetUrls() {
      this.urlInfo = [
        {
          variation: 0,
          value: ""
        }
      ];
    },
    deleteRow(key) {
      if (this.urlInfo.length > 1) {
        this.urlInfo.splice(key, 1);
      }
    },
    validateLinks() {
      this.removes_last_delimiter();
      console.log("test data for validate links 1");
      const data = {
        task: "validate_raw_links",
        payload: {
          raw_links: {
            //follow the old api for variables
            productInfo: {
              state: "addition",
              product_id: this.$store.state.productionModule.selected_product.id
            },
            urlInfo: this.urlInfo
          }
        }
      };
      console.log("test data for validate links", data);
      this.$store.dispatch("productionModule/general_api", data).then(res => {
        productionBus.$emit('open_snackbar', { text: res.data.message, color: 'warning'} )
        ////////// put url_id on the new urls (valids) with url_id = 0
        res.data.payload.valid.product_domains.forEach( dom => {
          dom.domain_urls.forEach( url => {
            if(url.url_id === 0){
              url.url_id = Math.floor(Math.random() * -1000);
            }
          })
        });
        console.log("adding urls result", res.data);
        /////////////// store the raw respond of validation
        const obj = {
          key: "conflict_temporary_urls",
          value: res.data.payload,
        };
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", obj);
        ////////////////////////////////////////////////////

        /////////////// store seperated products
        const products = res.data.payload.invalid.duplicate_products.map(
          prod => prod.product_info
        );
        console.log('fetched products', products)
        this.$store.commit( "productionModule/PUSH_PRODUCTION_STATE", {value: [...products] , key: "fetched_products_info" } );
        ////////////////////////////////////////

        // const invalids = res.data.payload.invalid.duplicate_products.map(
        //   product => product.product_domains
        // )
        //////////////// store invalids urls
        let invalids = [];
        res.data.payload.invalid.duplicate_products.forEach(product => {
          product.product_domains.forEach(product_domain => {
            invalids.push(product_domain);
          })
        });
        // RESET INVALIDS - talk again with tom
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", {key: 'invalid_domains_urls' , value: []})
        this.$store.commit( "productionModule/PUSH_PRODUCTION_STATE", {key:"invalid_domains_urls", value: invalids} );
        ////////////////////////////////////
        ////////////// store valids urls
        console.log('res.data.payload.valid.product_domains', res.data.payload.valid.product_domains)
        // RESET VALIDS - talk again with tom
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", {key: 'valid_domains_urls' , value: []})
        // console.log('valids_with_ids 2', valids_with_ids)
        this.$store.commit( "productionModule/PUSH_PRODUCTION_STATE", {key:"valid_domains_urls", value: res.data.payload.valid.product_domains} );
        ////////////////////////////////
        /////////// store products_ids only of conflict, showConflict flag = true
        if( res.data.payload.invalid.duplicate_products.length > 0 ){
          this.$store.commit("productionModule/SET_PRODUCTION_STATE", {value: true, key: "showConflict"});
          const products_ids = products.map( id => id.product_id );
          this.$store.commit("productionModule/PUSH_PRODUCTION_STATE", {value: products_ids, key: "products_ids_with_conflict"});
        }
        //////////////////////////////////////////////////////////////////////////
      });
      /////// close validation dialog
      // this.resetUrls(); // reset urls after validation urls
      this.$emit('close_validation');
    },
    removes_last_delimiter () {
      this.urlInfo.forEach(u => {
        (u.value.endsWith('::!::')) && //if ends then
        (u.value = [...u.value].reverse().join("").replace("::!::","").split("").reverse().join(""))
        // removes ::!:: from the end
      })
    },
    unzip_umbrella() {
      const splitted_string = [];
      let variation_id = 0;
      let remember_index = [];
      this.urlInfo.forEach((element, index) => {
        if(element.value.includes('::!::')){
          splitted_string.push(...element.value.split('::!::'));
          variation_id = element.variation;
          remember_index.push(index);
        }
      });
      console.log('infos', variation_id, remember_index)
      console.log('splitted_string', splitted_string)
      for (let i = remember_index.length-1; i >= 0; i--) {
        this.urlInfo.splice(remember_index[i], 1)
      }
      console.log('new_urlInfo', this.urlInfo)
      const new_entries = splitted_string
                          .filter(string => !!string)
                          .map(str => ({
                            value: str,
                            variation: variation_id,
                          }))
      this.urlInfo.push(...new_entries);
      console.log('new_urlInfo 2', this.urlInfo)
    }
  },
  created() {
    productionBus.$on('clear_add_urls', this.resetUrls)
  },
};
</script>



// WEBPACK FOOTER //
// src/components/production/N_Add_Url.vue